
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import VeiculoData, { VeiculoDataRequired } from "./VeiculoData";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import { mask } from "vue-the-mask";

export default {
  name: "app-veiculos-form",
  directives: {
    mask,
  },
  components: {
    Money,
    VueSelect,
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      configMoney: settingMoney,
      form: {},
      grupos: [],
      anp: null,
      cstscofins: [],
      tipo_rodado: null,
      tiposRodados: [],
      tiposCaroceria: [],
      caroceriaError: false,
      rodadosError: false,
    };
  },
  validations: {
    form: VeiculoDataRequired,
  },
  watch: {
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  created() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.setLoading(true);
      this.form = new VeiculoData({});
      try {
        const { data: tiposRodados } = await this.$http.post('/veiculos/get-tipo-rodado');
        this.tiposRodados = tiposRodados;

        const { data: tiposCaroceria } = await this.$http.post('/veiculos/get-tipo-caroceria');
        this.tiposCaroceria = tiposCaroceria;

        if (this.$route.params?.veiculoData) {
          const veiculoData = this.$route.params?.veiculoData
          this.form = veiculoData;
          this.form.tipo_caroceria = this.tiposCaroceria.find(caroceria => caroceria.id === veiculoData.tipo_caroceria);
          this.form.tipo_rodado = this.tiposRodados.find(rodado => rodado.id === veiculoData.tipo_rodado);
        }
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActivePreviousTab() {
      this.tabIndex = parseInt(localStorage.getItem("builderTab")) || 0;
      const links = this.$refs["builder-tab"].querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.$refs["builder-tab"]
        .querySelector(`[data-tab="${this.tabIndex}"]`)
        .classList.add("active");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },

    async onSubmit() {
      this.addLoadingToButton("submit_novo_veiculo")

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          if (this.$v.form.tipo_rodado.$anyError) {
            this.$toast.error("Preencha o tipo rodao!");
            this.rodadosError = true;
          }
          if (this.$v.form.tipo_caroceria.$anyError) {
            this.$toast.error("Preencha o tipo de caroceria!");
            this.caroceriaError = true;
          }
          this.removeLoadingToButton('submit_novo_veiculo')
          return;
        }
        const url = this.$route.params?.veiculoData?.id_veiculo ?
          '/veiculos/update'
          :
          '/veiculos/create'

        await this.$http.post(url, {
          ...this.form,
          tipo_rodado: this.form.tipo_rodado.id,
          tipo_caroceria: this.form.tipo_caroceria.id,
        });

        this.$router.push({ name: "veiculos" });
      } catch (error) {
        console.log(error)
      }
      this.removeLoadingToButton('submit_novo_veiculo')
    },
  },
};
